import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import FormEighth from "./SelectCampaignChannel";
import { useAxiosCustomToken } from "../../../../hooks";
import { Autocomplete, ComponentHeader, Label } from "../../../../components";

export default function FormSeventh({
  component = "",
  formikProps,
  editState,
  agentToken,
  setAgentToken,
  preferredChannels,
}) {
  const { accessToken, authToken } = useSelector(
    (state) => state.memberDetails
  );
  const x_sso_token = sessionStorage.getItem("ida_sso_login");

  const [agents, setAgents] = useState([]);
  const [smsServiceAgents, setSmsServiceAgents] = useState([]);

  const { ID } = useSelector((state) => state.memberDetails.activeBrand);

  const axios = useAxiosCustomToken({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token ? authToken : "Bearer " + accessToken,
  });

  return (
    <Fragment>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Preferred Channel"}
          subtitle={
            component === ""
              ? "Select channel where you want to run the campaign"
              : "Selected Channel"
          }
        />
      </Grid>

      <Grid item xs={6}>
        <Label
          title="Select Preferred Channel"
          formikProps={formikProps}
          required={true}
          name="pref_campaign_channel.value"
        />

        <Autocomplete
          required={true}
          forcePopupIcon={!editState ? false : true}
          name="pref_campaign_channel.value"
          formikProps={formikProps}
          disabled={!editState}
          placeholder="Select Preferred Channel"
          defaults={{
            primaryKey: "id",
            displayLabel: "channel_name",
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              display: !editState && "none",
            },
          }}
          options={preferredChannels}
          getOptionDisabled={(option) =>
            !option.is_active || !option.is_enabled
          }
          onChange={(_, value, type) => handleChangeChannel(value, type)}
        />
      </Grid>

      <FormEighth
        setAgents={setAgents}
        setSmsServiceAgents={setSmsServiceAgents}
        agents={agents}
        smsServiceAgents={smsServiceAgents}
        agentToken={agentToken}
        setAgentToken={setAgentToken}
        formikProps={formikProps}
        editState={editState}
      />
    </Fragment>
  );

  function handleChangeChannel(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        pref_campaign_channel: { value: value.id },
      }));

      var url;

      url = `/bot/agents?brand_id=${ID}&channel_id=${value.id}`;

      if (value.id === 15) {
        url = `/bot/agents?brand_id=${ID}&channel_id=${value.id}&service=bsa`;
      }
      if (url) {
        axios({
          url: url,
          method: "post",
          data: {},
          disableRedirect: true,
          customAuthToken:
            x_sso_token !== null ? authToken : "Bearer " + accessToken,
        }).then((res) => {
          if (res.status) {
            if (value.id === 15) {
              axios({
                url: `/bot/agents?brand_id=${ID}&channel_id=${value.id}&service=indosat`,
                data: {},
                method: "post",
                disableRedirect: true,
                customAuthToken:
                  x_sso_token !== null ? authToken : "Bearer " + accessToken,
              }).then((response) => {
                if (response.status) {
                  setSmsServiceAgents(response.data);
                }
              });
            }
            setAgents(res.data);
          }
        });
      }
    } else {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        pref_campaign_channel: { value: "" },
      }));
    }
  }
}
